import script from "./FormulasFormulaCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasFormulaCard.vue?vue&type=script&setup=true&lang=js"

import "./FormulasFormulaCard.vue?vue&type=style&index=0&id=f709aaec&lang=scss"

const __exports__ = script;

export default __exports__